import AboutComponent from "@/components/AboutComponent/AboutComponent";
import BannerComponent from "@/components/BannerComponent/BannerComponent";
import MemberComponent from "@/components/MemberComponent/MemberComponent";
import assest from "@/json/assest";
import Wrapper from "@/layout/wrapper/Wrapper";
import { Box, List, ListItem, Typography } from "@mui/material";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Image from "next/image";
import Link from "next/link";
import { useQuery } from "react-query";
import {
  TeamMembers,
  fetchWebAbout,
  fetchWebAboutTeams,
} from "@/api/functions/cms.api";
import { mediaUrl } from "@/api/endpoints";
import { NextSeo } from "next-seo";

export async function getStaticProps() {
  const res = await fetchWebAbout();
  const res2 = await fetchWebAboutTeams();

  return {
    props: {
      res,
      res2,
    },
    revalidate: 100,
  };
}
export default function index({ res, res2 }: any) {
  // const {data, isLoading} = useQuery({queryKey:["fetchAbout"], queryFn:fetchWebAbout})
  // const {data:teamMembers} = useQuery({queryKey:["fetchAboutTeams"], queryFn:fetchWebAboutTeams})
  console.log(res);
  console.log(res2);
  // const res = {...data?.data}
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    // lazyLoad: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const bannerData = {
    heading: "about us",
    subHeading: "Lorem ipsum dolor sit amet consectetur",
    paragraph:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  };

  const memberData = [
    {
      image: `${assest.team1}`,
      name: "john doe",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
    {
      image: `${assest.team2}`,
      name: "Valentina Keppel",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
    {
      image: `${assest.team3}`,
      name: "Olive Yew",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
    {
      image: `${assest.team1}`,
      name: "john doe",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
    {
      image: `${assest.team2}`,
      name: "Valentina Keppel",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
    {
      image: `${assest.team3}`,
      name: "Olive Yew",
      role: "Partner",
      social: [
        {
          icon: `${assest.team4}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team5}`,
          path: "javascript:void(0)",
        },
        {
          icon: `${assest.team6}`,
          path: "javascript:void(0)",
        },
      ],
    },
  ];

  return (
    <>
      <Wrapper>
        <NextSeo noindex={false} nofollow={false} />
        <BannerComponent
          image={`about_web/${res?.data.section1_image}`}
          width={290}
          height={506}
          imageP={assest.bannerP2}
          width2={390}
          height2={506}
          addClass={true}
        >
          <Box className="ban_lft">
            <Box className="banner-slide">
              <Box className="banner-inr">
                <Typography variant="h1">{res?.data.section1_title}</Typography>
                <Typography variant="body1" className="sub_hd">
                  {res?.data.section1_smalltitle}
                </Typography>
                <Typography
                  variant="body1"
                  dangerouslySetInnerHTML={{
                    __html: res.data.section1_content,
                  }}
                ></Typography>
              </Box>
            </Box>
          </Box>
        </BannerComponent>

        <AboutComponent
          addClass={true}
          image={`about_web/${res?.data.section2_image}`}
          heading={res?.data.section2_title}
          subHeading={res?.data.section2_smalltitle}
          paragraph={res?.data.section2_content}
          buttonText={res?.data.section2_button_text}
          buttonLink={res?.data.section2_button_link}
        />
        {/* August 16th start*/}

        {/* <MemberComponent heading="Our team members">
          <Slider {...settings} className="global_slick slick_custom_about">
            {res2.data && res2?.data?.map((data:TeamMembers) => {
              return (
                <Box className="member_slide" key={data._id}>
                  <Box className="member_inr">
                    <figure>
                      <Image src={mediaUrl(`/teams/${data.image}`)} alt="" width={283} height={338} />
                    </figure>
                    <Typography variant="h3">{data.title}</Typography>
                    <Typography variant="caption">{data.profession}</Typography> */}

        {/* August 16th end*/}

        {/* <List className="social">
                      {memberData[1].social.map((item, index) => (
                        <ListItem disablePadding key={item.path}>
                          <Link href={data.} target="__blank">
                            <Image
                              src={item.icon}
                              alt=""
                              width={13}
                              height={10}
                            />
                          </Link> 
                        </ListItem>
                      ))}
                    </List> */}

        {/* August 16th start*/}
        {/* <List className="social">
          {data.facebooklink ? <ListItem disablePadding>
            <Link href={`https://${data.facebooklink}`} target="__blank">
              <Image
                src={assest.team4}
                alt=""
                width={13}
                height={10}
              />
            </Link>
          </ListItem> : <></>}
          {data.twitterlink ? <ListItem disablePadding>
            <Link href={`https://${data.twitterlink}`} target="__blank">
              <Image
                src={assest.team5}
                alt=""
                width={13}
                height={10}
              />
            </Link>
          </ListItem> : <></>}
          {data.instagramlink ? <ListItem disablePadding>
            <Link href={`https://${data.instagramlink}`} target="__blank">
              <Image
                src={assest.team6}
                alt=""
                width={13}
                height={10}
              />
            </Link>
          </ListItem> : <></>}
        </List>
      </Box>
    </Box >
              );
})}
          </Slider >
        </MemberComponent > */}

        {/* August 16th end*/}
      </Wrapper>
    </>
  );
}
